<template>
  <div class="title-container">
    <div :class="{'ttlcentr':ttlcentr}">
      <h2 class="ttl" :style="{ color: ttlcolor}">
        <slot name="ttl"></slot>
      </h2>
    </div>
    <!--		<b-col v-else cols="12" class="d-flex justify-content-center">-->
    <!--			<h2 class="ttl">-->
    <!--				<slot name="ttl"></slot>-->
    <!--			</h2>-->
    <!--		</b-col>-->
    <!--		<b-col v-if="!ttlcentr" cols="12" md="6" lg="4">-->
    <!--			<p class="subttl">-->
    <!--				<slot name="subttl"></slot>-->
    <!--			</p>-->
    <!--		</b-col>-->
  </div>
  <!--<div class="d-flex">
		<h2 class="ttl">
			<slot name="ttl"></slot>
		</h2>
		<p class="subttl">
			<slot name="subttl"></slot>
		</p>
  </div>-->
</template>

<script>
export default {
  props: {
    ttlcentr: Boolean,
    ttlcolor: String
  }
};
</script>

<style lang="scss" scoped>
.ttl {
  font-size: 44px;
  line-height: 110%;
  color: $darkColor;
  margin-bottom: 52px;
  @media only screen and (max-width: $md),
    only screen and (max-device-width: $md) {
    font-size: 24px;
    margin-bottom: 30px;
  }
}

.subttl {
  font-size: 22px;
  line-height: 115.3%;
  color: #fffdfd;
  margin-bottom: 0;
  @media only screen and (max-width: $md),
    only screen and (max-device-width: $md) {
    font-size: 16px;
    margin-bottom: 30px;
  }
}

.ttlcentr {
  @media only screen and (max-width: $sm),
    only screen and (max-device-width: $sm) {
    text-align: center;
  }
}
</style>